import {useEffect, useRef, useState} from "react";
import NewMovieCard from "../movie-card/NewMovieCard";
import ScrollGridButton from "../buttons/ScrollGridButton";
import {IChannel} from "../../interfaces/IChannel";
import NewMovieCardSkeleton from "../movie-card/NewMovieCardSkeleton";

interface Props {
    channels: IChannel[];
    skeletonLoadingItemQuantity: number;
}

type buttonMode = "PREV" | "NEXT";

export default function NewMovieGrid({
                                         channels,
                                         skeletonLoadingItemQuantity,
                                     }: Props) {
    const scrollXRef = useRef<HTMLDivElement>(null);
    const [scrollPostionX, setscrollPostionX] = useState(0);
    const [scrollXWidth, setScrollXWidth] = useState<number>(0);

    const scrollFunc = (mode: buttonMode) => {
        let scrollWidth = 0;
        if (scrollXRef.current) scrollWidth = scrollXRef.current.scrollWidth;
        let newPostionX = 0;
        if (mode === "NEXT") {
            newPostionX = scrollPostionX + 600;
            if (scrollWidth && newPostionX >= scrollWidth) newPostionX = scrollWidth;
        } else {
            newPostionX = scrollPostionX - 600;
            if (newPostionX < 0) newPostionX = 0;
        }
        scrollXRef?.current?.scrollTo({left: newPostionX, behavior: "smooth"});
        if (scrollWidth && scrollXRef.current)
            setScrollXWidth(scrollWidth - scrollXRef.current.clientWidth);
    };

    const handleScrollX = (event: React.UIEvent<HTMLElement>) => {
        setscrollPostionX(event.currentTarget.scrollLeft);
        if (scrollXRef.current)
            setScrollXWidth(
                scrollXRef.current.scrollWidth - scrollXRef.current.clientWidth
            );
    };

    useEffect(() => {
        if (scrollXRef.current)
            setScrollXWidth(
                Math.ceil(
                    scrollXRef.current.scrollWidth - scrollXRef.current.clientWidth
                )
            );
    }, [channels]);

    return (
        <div className={"relative"}>
            <ScrollGridButton
                direction={"PREV"}
                scrollFunc={scrollFunc}
                scrollPositionX={scrollPostionX}
                scrollXWidth={scrollXWidth}
            />
            <div
                onScroll={(e) => handleScrollX(e)}
                ref={scrollXRef}
                className="snap-x snap-mandatory pl-4 md:pl-0 scroll-pl-4 md:scroll-pl-0 scrollbar-hide flex space-x-4 w-full overflow-x-auto"
            >
                {/* <div className="w-4"></div> */}
                {channels.length ? (
                    channels.map((item) => (
                        <NewMovieCard key={item.ch_id} item={item} className={'w-72 md:w-96 shrink-0'}></NewMovieCard>
                    ))
                ) : (
                    <>
                        {[...Array(skeletonLoadingItemQuantity)].map((_, i) => (
                            <NewMovieCardSkeleton key={i}/>
                        ))}
                    </>
                )}
            </div>
            <ScrollGridButton
                direction={"NEXT"}
                scrollFunc={scrollFunc}
                scrollPositionX={scrollPostionX}
                scrollXWidth={scrollXWidth}
            />
        </div>
    );
}
